import React from "react";

const SearchIcon = () => (
	<svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M11.4366 2.94966C8.82662 0.339698 4.56743 0.339698 1.95747 2.94966C-0.652489 5.55961 -0.652489 9.81881 1.95747 12.4288C4.29522 14.7665 7.92995 15.0227 10.5399 13.1813L14.0305 16.6719C14.4789 17.1203 15.2154 17.1203 15.6637 16.6719C16.1121 16.2236 16.1121 15.4871 15.6637 15.0387L12.1731 11.5321C14.0145 8.92213 13.7743 5.28741 11.4366 2.94966ZM9.93145 10.9236C8.1381 12.717 5.23993 12.717 3.4626 10.9236C1.66925 9.13029 1.66925 6.23212 3.4626 4.45478C5.25594 2.67745 8.15411 2.66144 9.93145 4.45478C11.7088 6.23212 11.7088 9.13029 9.93145 10.9236Z" fill="#6C757D" />
	</svg>
);

export default SearchIcon;